
let galleryId;
const galleries = document.querySelectorAll('.gallery-grid');

const gallerySliderInit = function() {
    galleries.forEach((galleryEl) => {
        galleryId = galleryEl.getAttribute('data-gallery-id');

        let gallerySwiper = new Swiper(`#gallery-slider-${galleryId}`, {
            // modules: [Navigation, Pagination, Autoplay],

            loop: true,
            slidesPerView: "auto",
            spaceBetween: 20,
            speed: 2000,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,

            },

            breakpoints: {
                1280: {
                    pagination: false,
                }
            },
        });
    });
}

const galleryFancyboxInit = function() {
    galleries.forEach((galleryEl) => {
        galleryId = galleryEl.getAttribute('data-gallery-id');

        // Default gallery
        Fancybox.bind(`.gallery-default [data-fancybox="gallery-${galleryId}"]`, {
            buttons: [
                "close"
            ],
            loop: true,
            protect: false,
            controls : false,
            caption : (fancybox, item) => {
                const caption = item.caption || '';
                return (caption)
            }
        });

        // Slider gallery
        Fancybox.bind(`.gallery-slider [data-fancybox="gallery-${galleryId}"]`, {
            infobar: false,
            toolbar: false,
            arrows: false,
            caption : (fancybox, item) => {
                const caption = item.caption || '';
                return (caption)
            }
        });
    });
}

export { gallerySliderInit, galleryFancyboxInit };
